import {
  ChannelOption,
  MarketingPreferencesOption,
  MarketingPreferencesRadioButtonsGroup,
  RegistrationAndRetentionFormType
} from '../../../../../@types/Marketing';

export const registrationTierTooltipValues: string[] = [
  'Tier 1 – Included in all available marketing activities client approval is not required.',
  'Tier 2 – Client approval required to be included in any marketing activities.',
  'Tier 3 – Excluded from all marketing activities, Engagement Center is available for self-support.',
  'Tier 4 – Excluded from all available marketing activities, no marketing support is provided.',
  'Tier 5 – White Label requires client-branded marketing customizations; Client approval is required for all marketing activities.'
];

export const registrationMCPTooltipValues: string[] = [
  'Tier 1 & Tier 2 – Minimum of Email or Direct Mail set to ‘Yes’.',
  'Tier 3 & Tier 4 – All channel permissions set to ‘No’ or ‘Not provided’.',
  'Tier 5 – Minimum of Email or Direct Mail set to ‘Yes’.'
];

export const dropdownOptions: MarketingPreferencesOption[] = [
  { label: 'Tier 1 - Fully Engaged', value: '1', minimumSet: true },
  { label: 'Tier 2 - Campaign Approval Required', value: '2', minimumSet: true },
  { label: 'Tier 3 - Self Support only', value: '3' },
  { label: 'Tier 4 - No Marketing Support', value: '4' },
  { label: 'Tier 5 - White Label', value: '5', minimumSet: true }
];

const defaultRadioButtonsGroupOptions = [
  {
    label: 'Yes',
    value: ChannelOption.YES
  },
  {
    label: 'No',
    value: ChannelOption.NO
  },
  {
    label: 'Not provided',
    value: ChannelOption.NOT_PROVIDED
  }
];

export const radioButtonsGroup: MarketingPreferencesRadioButtonsGroup[] = [
  {
    label: 'Email',
    id: 'email',
    checkedValue: ChannelOption.YES,
    options: defaultRadioButtonsGroupOptions
  },
  {
    label: 'Direct mail',
    id: 'directMail',
    checkedValue: ChannelOption.YES,
    options: defaultRadioButtonsGroupOptions
  },
  {
    label: 'Phone',
    id: 'phone',
    checkedValue: ChannelOption.YES,
    options: defaultRadioButtonsGroupOptions
  },
  {
    label: 'Text message',
    id: 'textMessage',
    checkedValue: ChannelOption.YES,
    options: defaultRadioButtonsGroupOptions
  }
];

export const sections: { type: RegistrationAndRetentionFormType; label: string }[] = [
  { type: RegistrationAndRetentionFormType.REGISTRATION, label: 'Registration / Enrollment marketing' },
  { type: RegistrationAndRetentionFormType.RETENTION, label: 'Retention marketing' }
];
